<!-- SG-7046 start -->
<div fxLayout="column" fxFlex="100%" fxLayoutAlign="stretch">
  <div style="padding: 18px 15px">
    <div fxLayoutAlign="space-between" fxLayout="row" *ngIf="dialogData && dialogData.header">
      <mat-card-subtitle cardHeader fxLayout="column" fxLayoutAlign="center">
        {{ dialogData.header }}
      </mat-card-subtitle>
      <div [ngClass]="['search-div']">
        <input (keyup)="applyFilter($event)" placeholder="Search" [ngClass]="['search-input']" #input />
        <mat-icon [ngClass]="['search-icon']">search</mat-icon>
      </div>
      <app-date-selector (changeDate)="getData($event, duplicate)" [selectedDateRange]="dateType"></app-date-selector>
      <div fxLayoutAlign="end center">
        <mat-icon pointer (click)="closeDialog()" style="color: #707070">close</mat-icon>
      </div>
    </div>
    <div fxLayout="row" style="max-height: calc(90vh - 100px);">
      <div fxLayout="column" fxFlex="100%" [ngClass]="['custom-table']" [fxHide]="data.length === 0" *ngIf="data && data.length > 0 && dataSource && dataSource.data.length > 0">
        <div style="max-height: calc(90vh - 150px); overflow-y: auto; overflow-x: auto;">
          <table mat-table [dataSource]="dataSource">
            <ng-container *ngFor="let column of columns; let i = index" [matColumnDef]="column.colDef">
              <th mat-header-cell *matHeaderCellDef scope="col" [ngStyle]="{ 'text-align': iscenterFlag && i != 0 ? 'center' : 'left' }">
                {{ column.name == "name Icon" ? "&nbsp; &nbsp;" : (column.name | titlecase) }}
              </th>
              <td
                mat-cell
                *matCellDef="let element"
                (click)="openUserDialog(element)"
                [matTooltip]="tooltip && i < tooltip ? element[column.colDef] : ''"
                (click)="getColName(column.name)"
                [ngStyle]="{ 'text-align': iscenterFlag && i != 0 ? 'center' : 'left' }"
              >
                <div
                  [ngStyle]="{ 'background-color': column.colDef == 'nameIcon' ? element.color : '' }"
                  [ngClass]="[column.colDef == 'role' ? element[column.colDef] : column.colDef, tooltip && i < tooltip ? 'tooltipDiv' : '']"
                >
                  <span *ngIf="column.colDef == 'averageCorrectAnswers'">{{ element[column.colDef] | number : "1.0-0" }}</span>
                  <span *ngIf="column.colDef == 'email'">{{ element["emailDec"] }}</span>
                  <span *ngIf="column.colDef == 'username'">{{ element["usernameDec"] }}</span>
                  <span *ngIf="column.colDef == 'nickname'">{{ element["nicknameDec"] }}</span>
                  <span *ngIf="column.colDef != 'averageCorrectAnswers' && column.colDef != 'nickname' && column.colDef != 'email' && column.colDef != 'username'">
                    <!-- SG-7515 -->
                    <span [matTooltip]="element[column.colDef]" matTooltipClass="tooltip-wrap">
                      {{ element[column.colDef].length > 30 ? element[column.colDef].substring(0, 30) + "..." : element[column.colDef] }}
                    </span>
                  </span>
                </div>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns" [style.cursor]="dialogData.redirectionKey ? 'pointer' : ''" (click)="redirection(row)"></tr>
          </table>
        </div>
        <div>
          <!--****************** SG-7046  ***************** -->
          <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]" [pageSize]="pageSize" (page)="onPageChange($event)" [length]="data.length"></mat-paginator>
        </div>
      </div>
      <div fxLayout="column" fxFlex="100%" *ngIf="message && data?.length === 0">
        <div fxLayout="row" fxFlex="100%" fxLayoutAlign="center center">
          {{ message }}
        </div>
      </div>

      <div fxLayout="column" fxFlex="100%" *ngIf="data?.length === 0 && !message">
        <div fxLayout="row" fxFlex="100%" fxLayoutAlign="center center">
          <mat-spinner diameter="20"></mat-spinner>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- SG-7046 end -->
